import bus from '@/utils/eventBus'
import { isMobile } from 'mobile-device-detect'
import { warning, success } from '@/utils/alert'

export default function () {
  this.doLoad()
  if (isMobile) {
    this.isMobiled = true
  }

  bus.$on('do-created-schedule', values => {
    if (values.show) {
      this.doLoad()
    }
  })

  bus.$on('do-not-exist', values => {
    this.isShowActive = false
    warning(values.msg.message)
  })

  bus.$on('schedule-actived', values => {
    this.isShowActive = false
    success(values.msg.message)
    this.doLoad()
  })
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/nexts/resources/mounted.js